import React from "react";
import { withTranslation } from 'react-i18next';
import { withSnackbar } from 'notistack';
import {
    Grid,
    Card,
    CardHeader,
    CardContent,
    CircularProgress,
    Button,
    TableCell,
    TableRow,
    Fab,
    TableContainer,
    Paper,
    Table,
    TableHead,
    TableBody,
    TablePagination
} from "@material-ui/core";
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import { getSpecificClients } from "views/clients/api/apiClients";
import { deleteVendor, getVendors, getVendorById } from "../api/apiVendor";
import CreateOrUpdateVendor from "./CreateOrUpdateVendor";
import ConfirmationDialog from "common/components/ConfirmationDialog";
import SelectClient from "common/components/custom/SelectClient";

class Vendors extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            specificsClients: [],
            isOpen: false,
            selectedClient: null,
            vendors: [],
            vendorToEdit: null,
            vendorToDelete: null,
            dialogOpen: false,
            isLoading: true,
            activePage: 0,
            totalElements: 0,
            rowsPerPage: 25
        };
    }

    async componentDidMount() {
        this.getSpecificClients()
    }

    getSpecificClients = () => {
        getSpecificClients().then((response) => {
            let selectedClient = response.data.data.length > 0 ? response.data.data[0] : null
            this.setState({ specificsClients: response.data.data, selectedClient: selectedClient, isLoading: false }, selectedClient ? this.getVendors(0, selectedClient.id) : null);
        }).catch(error => {
            this.props.enqueueSnackbar(this.props.t("something_went_wrong"), { variant: 'error' });
        });
    }

    getVendors = (page, selectedClient) => {
        this.setState({ isLoading: true })
        getVendors({ params: { page: page, size: this.state.rowsPerPage } }, selectedClient).then((response) => {
            this.setState({
                vendors: response.data.data.content,
                totalElements: response.data.data.totalElements,
                isLoading: false
            });
            if (page > 0 && response.data.data.content.length === 0) {
                this.setState({ activePage: page }, () => this.getVendors(page - 1, this.state.selectedClient));
            }
        }).catch(error => {
            this.props.enqueueSnackbar(this.props.t("something_went_wrong"), { variant: 'error' });
        });
    }

    getVendorById = (id) => {
        getVendorById(id).then(response => {
            this.setState({ vendorToEdit: response.data.data, isOpen: true });
        }).catch(error => {
            this.props.enqueueSnackbar(this.props.t("error_get_employee_by_id"), { variant: 'error' });
        });
    }

    deleteVendor = () => {
        let { vendorToDelete } = this.state
        deleteVendor(vendorToDelete.id).then(response => {
            this.props.enqueueSnackbar(this.props.t("delete_message_vendor", { name: this.state.vendorToDelete.name }), { variant: 'success' });
            this.setState({ dialogOpen: false, vendorToDelete: null, rowsPerPage: this.state.rowsPerPage }, () => this.getVendors(0, this.state.selectedClient.id));
        }).catch(error => {
            this.props.enqueueSnackbar(this.props.t("error_delete_vendor", { name: this.state.vendorToDelete.name }), { variant: 'error' });
        });
    }

    handleChange = (client) => {
        if (client !== null) {
            this.setState({ selectedClient: client }, () => this.getVendors(0, client.id))
        } else {
            this.setState({ selectedClient: null })
        }
    }

    handleChangePage = (event, newPage) => {
        this.setState({ activePage: newPage }, () => this.getVendors(newPage, this.state.selectedClient.id))
    };

    handleChangeRowsPerPage = (event) => {
        this.setState({ rowsPerPage: parseInt(event.target.value, 10), activePage: 0 }, () => this.getVendors(this.state.activePage, this.state.selectedClient.id))
    };

    closeDialog = () => {
        this.setState({ isOpen: false, vendorToEdit: null });
    }

    render() {

        let { vendors, isOpen, specificsClients, isLoading, selectedClient, vendorToEdit, vendorToDelete, dialogOpen } = this.state;

        if (isLoading) {
            return (
                <div className="loading-position">
                    <CircularProgress className="spinner" color="primary" />
                </div>
            )
        }

        let vendorsList;
        let recordsNotFound;
        if (vendors && vendors.length > 0) {
            vendorsList = vendors.map((vendor, index) => {
                return <TableRow key={index}>
                    <TableCell>{vendor.name}</TableCell>
                    <TableCell>{vendor.address}</TableCell>
                    <TableCell>{vendor.oib}</TableCell>
                    <TableCell>{vendor.city}</TableCell>
                    <TableCell>{vendor.postalCode}</TableCell>
                    <TableCell>{vendor.country}</TableCell>
                    <TableCell>{vendor.isActive ? <CheckIcon fontSize="small" className="fa fa-plus-circle" style={{ color: 'green' }} /> : <CloseIcon fontSize="small" className="fa fa-plus-circle" style={{ color: 'red' }} />}</TableCell>
                    <TableCell>
                        <Fab title={this.props.t("edit")} onClick={() => this.getVendorById(vendor.id)} size="small" style={{ marginRight: 10 }} color="secondary" aria-label="edit">
                            <EditIcon />
                        </Fab>
                        <Fab title={this.props.t("delete")} onClick={() => this.setState({ vendorToDelete: vendor, dialogOpen: true })} size="small" style={{ marginRight: 10 }} color="inherit" aria-label="delete">
                            <DeleteIcon />
                        </Fab>
                    </TableCell>
                </TableRow >
            });
        } else {
            recordsNotFound = <TableRow>
                <TableCell align="center" colSpan={6}>
                    <p>{this.props.t("no_records_found")}</p>
                </TableCell>
            </TableRow>
        }

        return <Grid container direction="row" spacing={2}>
            <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                <CardHeader
                    title={this.props.t("vendors")}
                    action={
                        selectedClient !== null && <Button variant="contained" color="secondary" aria-label="edit" onClick={() => this.setState({ vendorToEdit: null, isOpen: true })} style={{ top: '4px' }}>
                            {this.props.t("add_new_vendor")}
                        </Button>
                    } />
                <Card>
                    <CardContent>
                        <Grid container direction="row" spacing={2}>
                            <Grid item container direction="column" xs={2} sm={2} md={2} lg={2} xl={2}>
                                <Grid container direction="row" spacing={2}>
                                    <SelectClient
                                        specificsClients={specificsClients}
                                        selectedClient={selectedClient}
                                        handleChange={this.handleChange}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        {selectedClient !== null && <><Grid container direction="row" spacing={2}>
                            <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid container direction="row" spacing={2}>
                                    <Grid item container>
                                        <TableContainer component={Paper}>
                                            <Table aria-label="simple table" size="small" style={{ tableLayout: 'fixed' }}>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell component="th" scope="row" width="20%">{this.props.t("name")}</TableCell>
                                                        <TableCell component="th" scope="row" width="15%">{this.props.t("address")}</TableCell>
                                                        <TableCell component="th" scope="row" width="10%">{this.props.t("oib")}</TableCell>
                                                        <TableCell component="th" scope="row" width="15%">{this.props.t("city")}</TableCell>
                                                        <TableCell component="th" scope="row" width="10%">{this.props.t("postal_code")}</TableCell>
                                                        <TableCell component="th" scope="row" width="15%">{this.props.t("country")}</TableCell>
                                                        <TableCell component="th" scope="row" width="5%">{this.props.t("active")}</TableCell>
                                                        <TableCell component="th" scope="row" width="10%"></TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {vendorsList}
                                                    {recordsNotFound}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>

                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                            <TablePagination
                                component="div"
                                count={this.state.totalElements}
                                rowsPerPageOptions={[10, 25, 50, 100]}
                                page={this.state.activePage}
                                onPageChange={this.handleChangePage}
                                rowsPerPage={this.state.rowsPerPage}
                                onRowsPerPageChange={this.handleChangeRowsPerPage}
                                backIconButtonText={this.props.t("previous_page")}
                                labelRowsPerPage={this.props.t("rows_per_page")}
                                nextIconButtonText={this.props.t("next_page")}
                            /></>}
                    </CardContent>
                </Card>
            </Grid>
            <CreateOrUpdateVendor
                isOpen={isOpen}
                onClose={this.closeDialog}
                selectedClient={selectedClient}
                vendorToEdit={vendorToEdit ? vendorToEdit : null}
                getVendors={() => this.getVendors(this.state.activePage, selectedClient.id)}
            />
            {
                vendorToDelete && <ConfirmationDialog
                    isOpen={dialogOpen}
                    title={this.props.t("delete_vendor")}
                    message={this.props.t("delete_vendor_dialog_message", { name: vendorToDelete.name })}
                    onClose={() => this.setState({ dialogOpen: false })}
                    onConfirm={() => this.setState({ dialogOpen: false }, () => this.deleteVendor())}
                    closeButtonTitle={this.props.t("close")}
                    confirmButtonTitle={this.props.t("delete")}
                />
            }
        </Grid >
    }
}

export default withSnackbar(withTranslation()(Vendors))